export class Product {
  constructor(
    public title: string = null,
    public description: string = null,
    public isOpen: boolean = false
  ) {}
}
